import './LoginFinder.scss'
import React, { Component } from 'react'
import ContentEditable from 'react-contenteditable'
import { Slide, Fade } from '@material-ui/core'
import {
    Video,
    Status,
    Scanning,
    ButtonArrow,
    Instruction,
    sdk,
    getBioDataFromVideo
} from '@svort/component'

import axios from '../../utils/axios'
import {
    imageDataToBase64,
    isMobile,
    delay
} from '../../utils/utils'
import { Translated } from '../../utils/translated'
import { ReactComponent as LoginLoader } from './loader.svg'

class LoginFinder extends Component {

    constructor(props) {
        super(props);

        this.state = {
            isInit: false,
            isSearch: false,
            isLogout: false,
            isLoginFound: false,
            isLoginNotFound: false,

            login: '',

            isError: false,
            isLoading: false,
            status: null,
            onRetry: () => {
                this.setState({
                    isError: false,
                    isInit: true,
                    isLoading: true,
                    status: 'permission_request'
                });
            }
        }

        this.videoRef = React.createRef();
        this.spanRef = React.createRef();
        this.offset = this.props.baseRadius / 30;
        this.baseRadius = Math.max(window.outerHeight, window.innerHeight) * 0.45 / 2;
        this.isMobile = isMobile();
    }

    componentDidMount() {
        if (!this.props.isShow)
            return

        if (this.props.login)
            this.setState({
                isLoginFound: true,
                login: this.props.login
            })
        else if (this.props.isLogout)
            this.setState({
                isLoginFound: true,
                isLogout: true
            })
        else this.checkSDKLoaded();
    }

    // componentDidUpdate() {
    //     if (this.props.isShow && this.props.login && !this.state.isLoginFound)
    //         this.setState({
    //             isSearch: false,
    //             isLoginNotFound: false,
    //             isLoginFound: true,
    //             login: this.props.login
    //         })
    // }

    checkSDKLoaded = () => {
        this.setState({
            isLoading: true,
            isPureStatus: true,
            status: <Translated id="downloading_sdk" values={{ progress: 0 }} />
        }, async () => {
            const isLoaded = await sdk.isLoaded();
            if (isLoaded)
                this.setState({
                    isPureStatus: false,
                }, () => this.onSearch());
            else sdk.setProgressListener((data) => {
                if (data.isLoaded)
                    this.setState({
                        isPureStatus: false,
                    }, () => this.onSearch());
                else this.setState({
                    status: <Translated id="downloading_sdk" values={{ progress: (data.currentProgress * 100 / data.dataSize).toFixed(1) }} />
                })
            });
        });
    }

    onSearch = () => {
        this.setState({
            isLoginFound: false,
            status: 'permission_request'
        }, () => setTimeout(() => {
            this.setState({
                isLogout: false,
                isInit: true,
                isLoading: true
            });
        }, 100));
    }

    onError = (message) => {
        const { message: errorMessage } = message;

        this.setState({
            isSearch: false,
            isLoading: false,
            isError: true,
            status: `server_response_error_${errorMessage}`
        });

        this.props.onError('server_response_error', { message: errorMessage });
    }

    onVideoCanPlay = () => {
        this.setState({
            isInit: false,
            isLoading: false,
            isSearch: true,
            status: 'prepare'
        }, () => {
            this.getPhoto();
        });
    }

    onVideoError = (error, message) => {
        console.log('video_error:', error, message);

        this.setState({
            isInit: false,
            isLoading: false,
            isError: true,
            status: error
        });
    }

    onStartEditLogin = () => {
        this.props.login && this.setState({
            isLoginError: false,
            isEditLogin: true
        }, () => {
            this.spanRef.current.focus();
        })
    }

    onFinishEditLogin = () => {
        const oldLogin = this.state.login;
        const newLogin = this.spanRef.current.textContent;

        if (oldLogin === newLogin) {
            this.setState({
                isEditLogin: false
            }); return
        }

        this.setState({
            isLoginSaving: true,
            login: newLogin
        }, async () => {
            const response = await axios.post('change_login', { login: oldLogin, newLogin, key: this.props.secret });
            const { status, message } = response;

            if (status === 'success')
                this.setState({
                    isEditLogin: false,
                    isLoginSaving: false
                });
            else this.setState({
                login: oldLogin,
                isEditLogin: false,
                isLoginSaving: false,
                isLoginError: true,
                loginError: message === 'user_already_exists' ? 'User already exists' : 'Error connecting to server'
            });
        });
    }

    getPhoto = async () => {
        const { imageData, bioData } = await getBioDataFromVideo(this.videoRef.current);

        if (bioData) {
            const photo = await imageDataToBase64(imageData);
            const response = await axios.post('check_identity', { photo });
            const { status, message, probables } = response;

            if (status === 'success' && probables.length > 0) {
                this.setState({
                    isSearch: false,
                    isLoginNotFound: false,
                    isLoginFound: true,
                    login: probables[0]?.login
                }); return;
            } else if (status === 'success' || message === 'face_not_found') {
                this.setState({ isLoginNotFound: true });
                await delay(500);
            } else this.onError({ message });
        }

        await delay(10);
        if (this.props.isShow && !this.state.isLoginFound && !this.state.isError && !this.state.isLoading)
            this.getPhoto();
    }

    render() {
        return (
            <Slide direction={'left'} in={this.props.isShow} timeout={{ enter: 800, exit: 500 }} mountOnEnter unmountOnExit>
                <div className='login-finder'>
                    {!this.state.isError && <>
                        <div className='content'>
                            <div className='space'></div>

                            <div className='fade' style={
                                !this.isMobile
                                    ? { width: this.baseRadius * 2, height: this.baseRadius * 2 }
                                    : this.state.isSearch
                                        ? { height: 'auto' }
                                        : {}}>

                                {(this.state.isInit || this.state.isSearch) &&
                                    <Video
                                        isInit={this.state.isInit}
                                        videoRef={this.videoRef}
                                        baseRadius={this.baseRadius}

                                        onVideoCanPlay={this.onVideoCanPlay}
                                        onError={this.onVideoError} />}

                                <Scanning
                                    isShow={this.state.isSearch}
                                    baseRadius={this.baseRadius} />

                                <Fade in={this.state.isLoginFound} timeout={{ enter: 1800, exit: 100 }} mountOnEnter unmountOnExit>
                                    <div className='login-found'>
                                        <div className='login-found-welcome-wrapper'>
                                            <p className='login-found-welcome'>
                                                <Translated id='app.loginless.welcome' />,&nbsp;
                                                {!this.state.isLogout
                                                    ? <ContentEditable
                                                        innerRef={this.spanRef}
                                                        html={this.state.login}
                                                        disabled={!this.state.isEditLogin}
                                                        onBlur={this.onFinishEditLogin}
                                                        onDoubleClick={this.onStartEditLogin}
                                                        onKeyDown={(e) => { (e.keyCode === 13 || e.keyCode === 27) && this.onFinishEditLogin() }}
                                                        tagName='span'
                                                    />
                                                    : <Translated id='app.loginless.anonymous' />}!
                                            </p>

                                            <div className='login-loader-error'>
                                                {this.state.isLoginSaving && <div className='login-loader'>
                                                    <LoginLoader />
                                                </div>}

                                                {this.state.isLoginError && <div className='login-error'>
                                                    {this.state.loginError}
                                                </div>}
                                            </div>

                                            {this.state.isLogout
                                                ? <Translated id='app.loginless.logout' />
                                                : this.props.login
                                                    ? <p><Translated id='app.loginless.created' /></p>
                                                    : <p><Translated id='app.loginless.found' /></p>}
                                        </div>

                                        <div className='login-found-controls'>
                                            {!this.state.isLogout &&
                                                <button
                                                    className='btn-gradient'
                                                    onClick={() => this.props.onLoginFound(this.state.login)}>
                                                    <Translated id='app.loginless.sign-in' />
                                                </button>}

                                            <ButtonArrow
                                                text={this.props.login
                                                    ? <Translated id='app.loginless.change-username' />
                                                    : <Translated id='app.loginless.try-again' />}
                                                isArrow={this.state.isLogout}
                                                isSmall={!this.state.isLogout}
                                                onClick={this.props.login ? this.onStartEditLogin : this.onSearch} />
                                        </div>
                                    </div>
                                </Fade>
                            </div>

                            <Fade in={!this.state.isLoading && !this.state.isLoginFound } timeout={300} mountOnEnter unmountOnExit>
                                <Instruction
                                    isShow={true}
                                    major={this.state.isLoginNotFound
                                        ? 'app.loginless.searching'
                                        : this.state.status}
                                    minor={this.state.isLoginNotFound &&
                                        'app.loginless.searching-hint'} />
                            </Fade>

                            <Fade in={!this.props.login && this.state.isLoginNotFound} timeout={{ enter: 800, exit: 100 }} mountOnEnter unmountOnExit>
                                <div className='login-not-found'>
                                    <button
                                        className='btn-gradient'
                                        onClick={() => this.props.onLoginNotFound()}>
                                        <Translated id='app.loginless.register' />
                                    </button>
                                    <p><Translated id='app.loginless.register-hint' /></p>
                                </div>
                            </Fade>
                        </div>
                    </>}

                    <Status
                        isShow={this.state.isLoading || this.state.isError}
                        isLoading={this.state.isLoading}
                        isError={this.state.isError}
                        isPure={this.state.isPureStatus}
                        onRetry={this.state.onRetry}>
                        {this.state.status}
                    </Status>
                </div>
            </Slide>
        )
    }
}

export default LoginFinder